import { render, staticRenderFns } from "./leftTabs.vue?vue&type=template&id=4204cb8f&scoped=true&"
import script from "./leftTabs.vue?vue&type=script&lang=js&"
export * from "./leftTabs.vue?vue&type=script&lang=js&"
import style0 from "./leftTabs.vue?vue&type=style&index=0&id=4204cb8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204cb8f",
  null
  
)

export default component.exports